import type { SVGProp } from './types';

export const chainlinkLabel = (props: SVGProp) => (
  <svg width="25" height="29" viewBox="0 0 25 29" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3853.00004242C12.7642-.00924782 15.6402 1.50506 24.4829 6.75405l.2283 14.58105-5.9347 3.4838c-3.2641 1.9185-6.0899 3.4792-6.2771 3.4746-.1872 0-3.07692-1.6212-12.4994-7.1907L.287605 6.84695 5.99405 3.43279C9.13031 1.55616 12.0064.00933267 12.3853.00004242ZM5.54666 18.3158l-.15065-8.52384 3.37822-1.88127c1.86257-1.03586 3.53797-1.88592 3.72517-1.89521.1872-.00465 1.7804.82683 6.7336 3.70681l.0183 8.59351-6.866 3.9483-6.83864-3.9483Z"
      fill="#1858E4"
    />
  </svg>
);
